import { Link } from "react-router-dom";
import type { OrderResponse } from "@hybrid-escrow/shared";
import { Money } from "./Money";
import { FinancialStatusBadge, DeliveryStatusBadge } from "./StatusBadge";
import { formatDateTime } from "../lib/format";
import { EmptyState } from "./States";

export function OrdersTable({
  orders,
  emptyLabel,
}: {
  orders: OrderResponse[];
  emptyLabel: string;
}) {
  if (orders.length === 0) {
    return <EmptyState title={emptyLabel} />;
  }

  return (
    <div className="table-wrap card">
      <table>
        <thead>
          <tr>
            <th>Item</th>
            <th>Total</th>
            <th>Payment</th>
            <th>Delivery</th>
            <th>Placed</th>
            <th>
              <span className="visually-hidden">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order.id}>
              <td>
                <div>{order.listingTitle}</div>
                <div className="mono text-sm muted">{order.orderId.slice(0, 12)}…</div>
              </td>
              <td>
                <Money baseUnits={order.totalChargedBaseUnits} />
              </td>
              <td>
                <FinancialStatusBadge status={order.financialStatus} />
              </td>
              <td>
                <DeliveryStatusBadge status={order.deliveryStatus} />
              </td>
              <td className="text-sm muted">{formatDateTime(order.createdAt)}</td>
              <td>
                <Link to={`/orders/${order.id}`} className="btn btn-secondary btn-sm">
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
